<template>
  <div
    class="x-container"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'XContainer',
};
</script>

<style lang="scss" scoped>
.x-container {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
